module.exports = __webpack_public_path__ + "img/icon-understand.14564da6.png";